import { HL7MessageTypeMappingsTable } from '@lmt/unicorn-shared/app/components/hl7/message-types/components/MessageTypeMappingsTable';
import React, { FC } from 'react';

import styles from './HL7MessageTypes.module.scss';

export const HL7MessageTypes: FC = React.memo(function HL7MessageTypes() {
  return (
    <div className={styles.storedScrolling} data-test-id="hl7-message-types">
      <div className={styles.table}>
        <HL7MessageTypeMappingsTable />
      </div>
    </div>
  );
});
